import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectPaisId } from 'legacyfrontend/redux/selectors/application-selectors';

export default function formasDePago() {
  const paisId = useSelector(selectPaisId);
  const { t } = useTranslation(['layout']);

  return (
    <div>
      {paisId === 2 ? (
        <div className='py-12 container w-3/4'>
          <h3 className='text-2xl text-gray-600 font-medium mb-6 text-center'>
            {t('footer.pay_methods')}
          </h3>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-6'>
            <div className='shadow-sm rounded-xl bg-white p-6 mb-6'>
              <h4 className='text-xl text-gray-600 font-medium'>
                Transferencias Bancarias o Depósitos
              </h4>
              <hr className='my-4' />
              <p className='text-sm text-gray-400 leading-relaxed'>
                Se confirma con el banco la transferencia.
              </p>
              <p className='text-sm text-gray-400 leading-relaxed'>
                {' '}
                Se confirma al pasajero por correo electrónico y/o Whatsapp la recepción de la
                transferencia de forma correcta.
              </p>
            </div>
            <div className='shadow-sm rounded-xl bg-white p-6 mb-6'>
              <h4 className='text-xl text-gray-600 font-medium mb-4'>
                Tarjetas de Crédito y Débito
              </h4>
              <hr className='my-4' />
              <p className='text-sm text-gray-400 leading-relaxed'>
                El pasajero recibirá por correo electrónico y/o Whatsapp un link de pago, por
                protección de datos.
              </p>
              <p className='text-sm text-gray-400 leading-relaxed'>
                El pasajero completará los datos de su tarjeta de crédito y/o débito y dará la
                confirmación del pago.
              </p>

              <p className='text-sm text-gray-400 leading-relaxed'>
                La agencia recibirá un correo electrónico con la confirmación del pago, donde se
                indica aceptadoSe confirma al pasajero por correo electrónico y/o Whatsapp la
                recepción del pago.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className='py-12 container w-3/4'>
          <h3 className='text-2xl text-gray-600 font-medium mb-6 text-center'>
            {t('footer.pay_methods')}
          </h3>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-6'>
            <div>
              <div className='shadow-sm rounded-xl bg-white p-6 mb-6'>
                <h4 className='text-xl text-gray-600 font-medium'>Tarjeta de débito</h4>
                <hr className='my-4' />
                <p className='text-sm text-gray-400 leading-relaxed'>
                  Pagá cualquiera de nuestros productos. Antes de hacerlo, tené en cuenta que tienen
                  un tope de extracción diario. Por eso, te sugerimos llamar al banco para chequear
                  cuánto dinero podés usar por día.
                </p>
              </div>
              <div className='shadow-sm rounded-xl bg-white p-6 mb-6'>
                <h4 className='text-xl text-gray-600 font-medium mb-4'>Efectivo</h4>
                <hr className='my-4' />
                <p className='text-sm text-gray-400 leading-relaxed'>
                  En cualquiera de nuestras sucursales, es importante que lleves el código de
                  reserva que te dió el vendedor. Podés pagar en pesos, dólares, euros (no se
                  aceptan de billetes 500) cualquier producto turístico nacional o internacional. Se
                  tomará el cambio del día para la conversión del precio.
                </p>
              </div>
            </div>
            <div>
              <div className='shadow-sm rounded-xl bg-white p-6 mb-6'>
                <h4 className='text-xl text-gray-600 font-medium mb-4'>Tarjeta de crédito</h4>
                <hr className='my-4' />
                <p className='text-sm text-gray-400 mb-2 leading-relaxed'>
                  Pagá en cuotas cualquier producto turístico. Consultá los detalles, las
                  restricciones de cada tarjeta de crédito y las promociones bancarias.
                </p>
                <p className='text-sm text-gray-400 leading-relaxed'>
                  Los productos expresados en dólares se debitarán en pesos argentinos al cambio del
                  día.
                </p>
              </div>
              <div className='shadow-sm rounded-xl bg-white p-6 mb-6'>
                <h4 className='text-xl text-gray-600 font-medium'>
                  Transferencia o depósito bancario
                </h4>
                <hr className='my-4' />
                <p className='text-sm text-gray-400 mb-2 leading-relaxed'>
                  Podés hacerlos personalmente en el banco, por cajero automático o desde tu
                  computadora.
                </p>
                <ul className='list-disc pl-3'>
                  <li className='text-sm text-gray-400 mb-2 leading-relaxed'>
                    El tiempo de acreditación varía entre 48 y 72 h de acuerdo al tipo de
                    transferencia que hagas. Si se hace desde el interior del país, el tiempo de
                    acreditación puede ser de hasta 96 h.
                  </li>
                  <li className='text-sm text-gray-400 mb-2 leading-relaxed'>
                    Si tenés cuenta en alguno de los bancos mencionados abajo, usala para la
                    transferencia: la acreditación es más rápida entre cuentas del mismo banco.
                  </li>
                </ul>
                <p className='text-sm text-gray-400 leading-relaxed'>
                  Una vez que hayas realizado el depósito o transferencia, envíale al vendedor el
                  cupón escaneado con tu nombre y apellido y código de reserva.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
